import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import { useContext, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { FormContainer } from "react-hook-form-mui";
import { APIContext } from "../../../../Contexts/APIContext";
import DropDownViewModel from "../../../../Utilities/ViewModels/DropDownViewModel";
import MonitoringReportV1ViewModel from "../../../ViewModels/TravelPlan/MonitoringReportV1ViewModel";
import MonitoringReportFeatures from "./MonitoringReportFeaturesV1";
import MonitoringReportImplementation from "./MonitoringReportImplementationV1";
import MonitoringReportModeSplits from "./MonitoringReportModeSplitsV1";
import MonitoringReportSelectionParameters from "../MonitoringReportShared/MonitoringReportSelectionParameters";
import MonitoringReportSiteDetails from "./MonitoringReportSiteDetailsV1";
import MonitoringReportSurveyResults from "../MonitoringReportShared/MonitoringReportSurveyResults";

interface IProps {
    typeDropdown: DropDownViewModel[] | [];
    groupDropdown: DropDownViewModel[] | [];
    id: string;
    parameterDropdown: DropDownViewModel[] | [];
    surveyTimesDropdown: DropDownViewModel[] | [];
    surveyEndTimesDropdown: DropDownViewModel[] | [];
    modeDropdown: DropDownViewModel[] | [];
}

export default function MonitoringReportTabsV1({ typeDropdown, groupDropdown, id, parameterDropdown, surveyTimesDropdown, surveyEndTimesDropdown, modeDropdown }: IProps) {
    const [tabVal, setTabVal] = useState(0);

    const formContext = useForm<MonitoringReportV1ViewModel>({
        defaultValues: new MonitoringReportV1ViewModel(),
    });

    const { reset } = formContext;
    const { get } = useContext(APIContext);

    useEffect(() => {
        getData();
    }, []);

    const getData = () => {
        get("TravelPlan", `GetTravelPlanMonitoringReport?id=${id}`, reset);
    };

    const tabChange = (event: React.SyntheticEvent, newValue: number) => {
        setTabVal(newValue);
    };
    const showResults = () => {
        setTabVal(4);
    };

    return (
        <>
            <Tabs value={tabVal} onChange={tabChange}>
                <Tab label="Selection Parameters" value={0} />
                <Tab label="Site Details" value={1} />
                <Tab label="Travel Plan Implementation" value={2} />
                <Tab label="Travel Plan Mode Splits & targets/Objectives" value={3} />
                <Tab label="Survey Results" value={4} disabled={true} />
                <Tab label="Travel Plan Features" value={5} />
            </Tabs>

            <FormContainer formContext={formContext} >
                {tabVal == 0 && (<MonitoringReportSelectionParameters parameterDropdown={parameterDropdown} surveyTimesDropdown={surveyTimesDropdown} surveyEndTimesDropdown={surveyEndTimesDropdown} onShowResults={showResults} modeDropdown={modeDropdown} reference={id} />)}
                {tabVal == 1 && <MonitoringReportSiteDetails formContext={formContext} />}
                {tabVal == 2 && <MonitoringReportImplementation typeDropdown={typeDropdown} />}
                {tabVal == 3 && <MonitoringReportModeSplits groupDropdown={groupDropdown} />}
                {tabVal == 4 && <MonitoringReportSurveyResults />}
                {tabVal == 5 && <MonitoringReportFeatures />}
            </FormContainer>
        </>
    );
}
